/**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2022 neutonhealth
 */

import { state as globalState, service as globalService } from '@/modules/global';

export default {
  mounted(el, binding, vnode) {
    const { value } = binding;
    const all_permission = '*:*:*';
    const getPermissions = globalState.permissions;

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;

      const hasPermissions = getPermissions.some(permission => {
        return all_permission === permission || permissionFlag.includes(permission);
      });

      if (!hasPermissions && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(`请设置操作权限标签值`);
    }
  },
};
